module.exports = "<div class=\"host\">\r\n  <h1>Page not found</h1>\r\n</div>\r\n"